module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p0"
  }, [_c('a', {
    attrs: {
      "id": "a4"
    }
  }), _c('span', {
    staticClass: "t1"
  }, [_vm._v("Shorts")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_vm._v("Gay Erotic Romance Box Set")]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_vm._v("14 Short Stories in 1 Collection!")]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_vm._v("By J.M. Snyder")]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t7"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("Table of Contents:")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('a', {
    attrs: {
      "id": "a6"
    }
  }), _c('a', {
    attrs: {
      "href": "#/005#a21"
    }
  }, [_vm._v("Joy Ride")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('a', {
    attrs: {
      "href": "#/006#a22"
    }
  }, [_vm._v("A Little Something for Santa")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    attrs: {
      "href": "#/007#a23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Poolside")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    attrs: {
      "href": "#/008#a24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pony Play")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    attrs: {
      "href": "#/009#a25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Escape")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    attrs: {
      "href": "#/010#a26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Best Friends")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    attrs: {
      "href": "#/011#a27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("One of Us")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    attrs: {
      "href": "#/012#a28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Threesome")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    attrs: {
      "href": "#/013#a29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Easily Addicted")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    attrs: {
      "href": "#/014#a30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hooking Up")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    attrs: {
      "href": "#/015#a31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Devilish Good Time")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    attrs: {
      "href": "#/016#a32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Battle of the Bands")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    attrs: {
      "href": "#/017#a33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Office Visit")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    attrs: {
      "href": "#/018#a34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The New Client")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-052cac22","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/004.vue
// module id = 63
// module chunks = 0